<!-- Header -->
<h3 mat-dialog-title
    translate>
    Email Not Sent
</h3>
<mat-dialog-content>
    <div>
        <span translate>The system was not able to send an email to your email address. Please contact the district for further instructions.</span>
    </div>
</mat-dialog-content>
<mat-dialog-actions style="position: sticky">
    <div class="footerRight">
        <tyl-button image="Cancel.png" label="Close" (clickEvent)="modalInstanceCloseClick()"></tyl-button>
    </div>
</mat-dialog-actions>